'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const SecondaryNavItemContext = React.createContext(void 0);
const useSecondaryNavItemContext = () => {
  return React.useContext(SecondaryNavItemContext);
};

exports.SecondaryNavItemContext = SecondaryNavItemContext;
exports.useSecondaryNavItemContext = useSecondaryNavItemContext;
//# sourceMappingURL=SecondaryNavItemContext.cjs.js.map
